<template>
  <v-app>
    <v-main>
      <v-overlay :value="this.$store.state.isLoading"><v-progress-circular color="primary" indeterminate :size="70" :width="7" /></v-overlay>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
